export default __webpack_public_path__ + "static/media/calendar.91884903.svg";